import { useMemo } from 'react';
import { DefaultTheme } from '@mui/styles';
type ChartStylesReturnProps = {
  VictoryChart: {
    height: number;
    padding: number;
    domainPadding: number;
  };
  VictoryBar: {
    width: number;
  };
  VictoryAxis: {
    axis: {
      stroke: string;
    };
    ticks: {
      stroke: string;
    };
    tickLabels: {
      fill: string;
    };
  };
  VictoryLabel: {
    fontSize: number;
    fontFamily: string;
    color: string;
  };
};
export const useChartStyles = (theme: DefaultTheme): ChartStylesReturnProps => {
  return useMemo(
    () => ({
      VictoryChart: {
        height: parseInt(theme.spacing(2.75)),
        padding: parseInt(theme.spacing(0)),
        domainPadding: 0
      },
      VictoryBar: {
        width: parseInt(theme.spacing(3.5))
      },
      VictoryAxis: {
        axis: { stroke: 'transparent' },
        ticks: { stroke: 'transparent' },
        tickLabels: { fill: 'transparent' }
      },
      VictoryLabel: {
        fontSize: 12,
        fontFamily: 'Roboto, Helvetica, Segoe UI, Arial, sans-serif',
        color: 'rgba(0, 0, 0, 0.5)'
      }
    }),
    [theme]
  );
};
